import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
export default {
  name: 'Language',

  data() {
    return {
      isOpen: true
    };
  },

  computed: _objectSpread({}, mapGetters({
    currentLocale: 'i18n/locale',
    locales: 'i18n/locales'
  }), {
    position() {
      return this.isOpen ? 'haut' : 'bas';
    },

    otherLocales() {
      return this.locales.filter(l => l.market !== this.currentLocale.market || l.language !== this.currentLocale.language);
    }

  }),

  mounted() {
    this.isOpen = false;
  },

  methods: {
    changeLocale(locale) {
      if (locale.market === 'US') {
        return 'https://us.maisonsdumonde.com/';
      }

      return "/".concat(locale.market, "/").concat(locale.language);
    }

  }
};